import { Component, Input } from '@angular/core';
import { IAddress } from 'src/app/components/cereri/cereri.interface';

@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss']
})
export class AddressComponent {
    @Input() address!: IAddress;
}
